/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * Description: Produkt Details
 * Hier werden die Eigenschaften eines Produktes in Form 
 * einer Tabelle aufgelistet
 * 
 * Beispiel: 
 * --------------+--------+---------
 * Tragfähigkeit | <Icon> | 1000 Kg
 * --------------+--------+---------
 * Baureihe      | <Icon> | BR 033
 * --------------+--------+---------
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import * as appActions from "../../../store/actions/appActions";
import { connect } from "react-redux";
import * as utils from "../../../basics/utils";

class ProductDetails extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { appModus } = this.props.app;
        const { iconList } = this.props.icon;
        const { height, node, version } = this.props

        let meta = {
            title: '',
            subTitle: '',
            description: '',
            url: '',
            tags: { theme: [], product: [] },
            details: []
        };

        const metaNode = node.children.filter(d => d.name === 'meta.json')
        if (metaNode.length > 0) {
            meta = metaNode[0].meta;
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        // ###############################################################
        // Small Version
        // ###############################################################
        const renderSmallVersion = (d, i) => {

            const size = 0.45

            /**
             * In der schmalen Version wird lediglich der Titel angezeigt
             */
            const renderTitle = () => {
                const style = {
                    marginTop: '-10px',
                    lineHeight: parseInt(height * .8) + 'px',
                    fontSize: parseInt(height * .65) + 'px'
                };

                return (
                    <div className={"w-full font-light pb-1 text-" + version} style={style}>
                        {node.name.replace(/_/g, ' ')}
                    </div>
                )
            }

            /**
             * ist in der meta.json das Tag 'Description' existiert, so werden
             * die dort definierten Zeilen angezeigt.  
             * Es werden maximal aber nur zwei Zeilen angezeigt
             */
            const renderDescription = () => {
                if (!meta['description']) return null;

                // sowohl ein array als auch ein String mit CR ist erlaubt
                const arrDescription = (Array.isArray(meta['description'])) ? meta['description'] : meta['description'].split('\n')

                const renderItem = (d, i) => {
                    if (i >= 2) return null; // nur zwei Zeilen anzeigen

                    return ((<tr key={i}><td className='flex overflow-hidden whitespace-no-wrap'>{d}</td></tr>))
                }

                const style = {
                    lineHeight: parseInt(height * .55) + 'px',
                    fontSize: parseInt(height * .48) + 'px'
                };

                const className = "items-center justify-center text-left overflow-x-hidden ";

                // ###############################################################
                // renderDescription()
                // ###############################################################
                return (
                    <tbody style={style} className={className}>
                        {arrDescription.map((d, i) => renderItem(d, i))}
                    </tbody>
                )
            }

            /**
             * Sind in der meta.json im Tag 'details' Produktdetails definiert, so werden
             * diese Details Zeilenweise angezeigt.  
             * Es werden maximal aber nur zwei Zeilen angezeigt
             */
            const renderDetails = () => {
                if (!meta['details']) return null;

                const renderProperties = (d, i) => {
                    if (i >= 2) return null; // nur zwei Properties anzeigen

                    const renderImage = () => {

                        let iconID = null;
                        if (d['id']) iconID = d.id;
                        if (d['icon']) iconID = d.icon;

                        if (iconID === null) return null;

                        const iconFound = iconList.filter((icon) => icon.id === iconID);
                        if (iconFound.length === 0) {
                            console.log('icon not found:', iconID);
                            return null;
                        }
                        const svg = iconFound[0].svg;

                        if (svg === '') return null;

                        const src = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));

                        const getStyle = () => {
                            return Object.assign(utils.getStyleHeight(height, size * 1.2, size * 1.2, size * 1.2), { width: (size * 40) + 'px' });
                        }

                        return (
                            <div style={getStyle()}>
                                <img src={src} width={height * .5} height={height * .5} alt="" />
                            </div>
                        )
                    }

                    const renderValue = () => {
                        const className = "items-center justify-center text-left overflow-x-auto overflow-y-hidden";

                        const style = {
                            lineHeight: parseInt(height * .55) + 'px',
                            fontSize: parseInt(height * .48) + 'px'
                        };
                        return <div style={style} className={className}>{d.value}</div>;
                    }

                    // ###############################################################
                    // renderProperties()
                    // ###############################################################
                    return (
                        <tr key={i}>
                            <td>{renderImage()}</td>
                            <td>{renderValue()}</td>
                        </tr>
                    )
                }

                // ###############################################################
                // renderDetails()
                // ###############################################################
                return (
                    <tbody>
                        {meta.details.map((d, i) => renderProperties(d, i))}
                    </tbody>
                )
            }

            // ###############################################################
            // renderSmallVersion
            // ###############################################################
            const style = Object.assign({ backgroundColor: 'transparent' }, utils.getStyleHeight(height, 0.9, 0.8, .8));

            return (
                <div className="flex flex-col px-2" style={style}>
                    {renderTitle()}
                    <div className={"flex justify-" + version}>
                        <table className="table-auto">
                            {(meta['description']) ? renderDescription() : renderDetails()}
                        </table>
                    </div>
                </div>
            )
        }

        // ###############################################################
        // Large Version
        // ###############################################################
        const renderLargeVersion = (d) => {

            const onEditTitle = () => {
                if (appModus === 'Admin') {
                    this.props.setModalDialog('ProductModal', 'update');
                }
            }

            const renderTitle = () => {

                const style = utils.getStyleHeight(height, .7, .7, .4)

                return (
                    <div className="w-full text-left font-bold whitespace-no-wrap" onClick={onEditTitle}>
                        <div style={style}>
                            {node.name.replace(/_/g, ' ')}
                        </div>
                    </div>
                )
            }

            const renderSubTitle = () => {
                const style = utils.getStyleHeight(height, .4, .3, .25)

                return (
                    <div className="w-full text-left font-normal whitespace-no-wrap" onClick={onEditTitle}>
                        <div style={style}>
                            {meta['subTitle'] && meta.subTitle.toUpperCase()}
                        </div>
                    </div>
                )
            }

            const renderProperties = (d, i) => {

                const renderTitle = () => {
                    const style = utils.getStyleHeight(height, .35, .35, .35);

                    return (<div className="w-full flex items-center justify-start text-left" style={style}>{d.title}</div>)
                }

                const renderImage = () => {

                    let iconID = null;
                    if (d['id']) iconID = d.id;
                    if (d['icon']) iconID = d.icon;

                    if (iconID === null) return null;

                    const iconFound = iconList.filter((icon) => icon.id === iconID);
                    if (iconFound.length === 0) {
                        console.log('icon not found:', iconID);
                        return null;
                    }
                    const svg = iconFound[0].svg;

                    if (svg === '') return null;

                    const src = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));

                    return (
                        <img src={src} width={height} height={height} alt="" />
                    )
                }

                const renderValue = () => {
                    const style = utils.getStyleHeight(height, .35, .35, .35);

                    return (<div className="w-full flex items-center justify-end text-right" style={style}>{d.value}</div>)
                }

                // ###############################################################
                // renderProperties()
                // ###############################################################
                const onClick = () => {
                    if (appModus === 'Admin') {
                        this.props.setModalDialog('ProductDetailsModal', 'update');
                    }
                }

                const style = utils.getStyleHeight(height, 1.1, 1, 1);

                return (
                    <div key={i} className="w-full flex border-t border-black" style={style} onClick={onClick}>
                        <div className="w-6/12 h-full flex items-center">{renderTitle()}</div>
                        <div className="w-1/12 h-full flex items-center">{renderImage()}</div>
                        <div className="w-5/12 h-full flex items-center">{renderValue()}</div>
                    </div>
                )
            }

            // ###############################################################
            // renderLargeVersion
            // ###############################################################
            return (
                <div className="w-full h-full flex flex-col justify-start text-left overflow-y-auto overflow-x-hidden" >
                    {renderSubTitle()}
                    {renderTitle()}
                    {(meta['details']) ? meta.details.map((d, i) =>
                        renderProperties(d, i)
                    ) : null}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        return (version === 'large') ? renderLargeVersion() : renderSmallVersion();
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        icon: state.icon
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
